export default async ({ store, redirect }) => {
  if (!store.state.global.loggedIn) {
    redirect('/login');
  } else if (store.state.global.user.phone_number === null) {
    redirect('/input-phone');
  } else if (store.state.global.user.phone_number_verified_at === null) {
    redirect('/otp');
  }
};
